import type { IconNode } from '../types';

/**
 * @name crosshair-plus
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTZ2NSIgLz4KICA8cGF0aCBkPSJNMTIgM3Y1IiAvPgogIDxwYXRoIGQ9Ik0xNiAxMmg1IiAvPgogIDxwYXRoIGQ9Ik0zIDEyaDUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/crosshair-plus
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const crosshairPlus: IconNode = [
  ['path', { d: 'M12 16v5', key: 'zza2cw' }],
  ['path', { d: 'M12 3v5', key: 'weuidg' }],
  ['path', { d: 'M16 12h5', key: 'rsdlri' }],
  ['path', { d: 'M3 12h5', key: 'p77gmy' }],
];

export default crosshairPlus;
